import { defineStore } from "pinia";
import { IAppUserInfo } from "@/types/app-user";

interface UserInfoStore {
  userInfo: IAppUserInfo;
}

export const useUserInfoStore = defineStore("user-info", {
  state: (): UserInfoStore => ({
    userInfo: {} as IAppUserInfo
  }),
  getters: {
    getUserInfo: state => state.userInfo
  },
  actions: {
    setUser(data: IAppUserInfo) {
      this.userInfo = data;
    }
  }
});
